import getDOMfromString from '../../../helpers/getDOMfromString';

/**
 * Generates arrow buttons for carousel
 *
 * @param {Object} config - options for btns
 * @returns {HTMLElement|string} - button/button string
 */
const createPointerArrowBtn = config => {
    const {customClasses = [], color = 'white', onClick, htmlStr = false, iconOnly = false} = config ?? {};
    const customClassesStr = Array.isArray(customClasses) ? customClasses.join(' ') : '';
    let elStr = ``;

    const svgStr = `<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5625 13.5L5.5 12.4375L11.4375 6.5H6V5H14V13H12.5V7.5625L6.5625 13.5Z" fill="${color}"/></svg>`;

    if (iconOnly) {
        elStr = svgStr;
    } else {
        elStr = `<button type="button" class="${customClassesStr}">${svgStr}</button>`;
    }

    if (htmlStr) {
        return elStr;
    }

    // DOM element
    const el = getDOMfromString(elStr);

    if (onClick) {
        el.onclick = onClick;
    }

    return el;
};

export default createPointerArrowBtn;
